import { IReduxState } from 'src/redux/IReduxState';
import { Column, EditableValue } from '../../components/BasicDataGrid';
import {
  IVirtualizedTableColumn,
  IVisibleTableColumnList,
} from '../../components/Table/VirtualizedTableInterfaces';

import ColumnFactory from '../../services/ColumnFactory';

/** Column keys for all columns to be displayed for options. */
export const OptionBasicViewKey = 'optionBasicView';
export const OptionTypeViewKey = 'optionTypeView';
export const OptionIndicatorsKey = 'optionIndicators';
export const AvailableStartKey = 'availableStart';
export const AvailableEndKey = 'availableEnd';
export const CategoryTextKey = 'categoryText';
export const CommentKey = 'comment';
export const ShorttextKey = 'shorttext';
export const LongtextKey = 'longtext';
export const FooterKey = 'footer';
export const DerivateStatesKey = 'derivateStates';
export const ConstraintKey = 'constraint';
export const ExclusionKey = 'exclusion';
export const PackageContentKey = 'packageContent';
export const UspKey = 'usp';
export const ReferenceKey = 'reference';
export const ReferenceExcKey = 'referenceExc';
export const StatusColumnKey = 'statusView';
export const PriceColumnKey = 'price';
export const IntSequenceKey = 'intSequence';
export const FlagKey = 'flags';
export const ChangedByKey = "changedBy";
export const ChangedTimestampKey = "changedTimestamp";
export const PdipTextKey ='pdiptext';

/** All possible columns supported for options. */
/** Order is important for displaying columns in table */
export const OptionColumnKeys = [
  CategoryTextKey,
  OptionBasicViewKey,
  IntSequenceKey,
  PdipTextKey,
  ShorttextKey,
  LongtextKey,
  FooterKey,
  UspKey,
  OptionIndicatorsKey,
  DerivateStatesKey,
  StatusColumnKey,
  CommentKey,
  ReferenceKey,
  ReferenceExcKey,
  AvailableStartKey,
  AvailableEndKey,
  ConstraintKey,
  ExclusionKey,
  PackageContentKey,
  PriceColumnKey,
  OptionTypeViewKey,
  FlagKey,
  ChangedByKey,
  ChangedTimestampKey,
];

export const OptionColumnsForHeightMeasurement = [
  PdipTextKey,
  ShorttextKey,
  LongtextKey,
  FooterKey,
  UspKey,
  CommentKey,
  ReferenceKey,
  ReferenceExcKey,
  ConstraintKey,
  ExclusionKey,
  PackageContentKey,
];

export const OptionColumnsTwoLanguage = [
  ShorttextKey,
  LongtextKey,
  FooterKey,
  UspKey,
];

/** Decide if a given column is visible by default (with factory settings). */
export const isInitiallyVisible = (key: string): boolean =>
  key === OptionBasicViewKey ||
  key === StatusColumnKey ||
  key === DerivateStatesKey ||
  key === ShorttextKey ||
  key === LongtextKey ||
  key === CommentKey;

/** Mapping of column key -> column params to be passed down to ColumnFactory. */
export type ColumnParams = { [key: string]: object };

/** Column param object assigned to this key is used with every column. */
export const ColumnParamAllKey: string = 'ALL_COLUMNS_KEY';

/** Create corresponding column for the given key. */
export const createColumn = (
  state: IReduxState,
  columnKey: string,
  params?: ColumnParams
): Column => {
  const combinedParams = Object.assign(
    {},
    params && params[ColumnParamAllKey] // params valid for every column
  );

  switch (columnKey) {
    case ShorttextKey:
      Object.assign(combinedParams, {
        keyEditable: EditableValue.Readonly,
      });
      break;
    case DerivateStatesKey:
      Object.assign(combinedParams, {
        derivates: [],
      });
      break;
    default:
      break;
  }
  return ColumnFactory.getColumnWithParameters(columnKey, combinedParams);
};

export function sortPSLColumns(
  a: IVirtualizedTableColumn,
  b: IVirtualizedTableColumn
): number {
  return OptionColumnKeys.indexOf(a.key) - OptionColumnKeys.indexOf(b.key);
}

export function sortPSLColumnsDropdown(
  list: IVisibleTableColumnList
): IVisibleTableColumnList {
  let columns: IVisibleTableColumnList = {};
  let sortedKeys = Object.keys(list);
  sortedKeys.sort((a, b) => {
    return OptionColumnKeys.indexOf(a) - OptionColumnKeys.indexOf(b);
  });

  sortedKeys.forEach((key) => {
    columns[key] = list[key];
  });

  return columns;
}



// WEBPACK FOOTER //
// ./src/views/OptionsView/OptionColumns.ts